import { Injectable, inject } from '@angular/core';
import { FormService } from '@eview/core/domain/form/form.service';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import {
  EFormAttributesActions,
  ListFormAttributes,
  ListFormAttributesFailure,
  ListFormAttributesSuccess
} from '../actions/form-attributes.actions';

@Injectable()
export class FormAttributesEffects {
  constructor(private formService: FormService) {}

  private readonly actions$ = inject(Actions);

  list$ = createEffect(() =>
    this.actions$.pipe(
      ofType<ListFormAttributes>(EFormAttributesActions.ListFormAttributes),
      switchMap(action =>
        this.formService.listAttributes(action.payload.id).pipe(
          map(payload =>
            payload
              ? new ListFormAttributesSuccess({
                  formId: action.payload.id,
                  attributes: payload
                })
              : new ListFormAttributesFailure()
          ),
          catchError(() => of(new ListFormAttributesFailure()))
        )
      )
    )
  );
}
